import type { FC } from "react";
import { Typography } from "../../../atoms";
import CircleCheckIcon from "../../../atoms/CircleCheckIcon";
import StatusWithBar, {
  HealthStatusWithLegacy,
} from "../../../atoms/StatusWithBar";
import ContentQualityCard from "../ContentQualityCard";
import { ContentQualityState, QualityMetric } from "../types";
import styles from "./index.style.module.css";

export interface ContentQualitySectionCardProps {
  state: ContentQualityState;
  filledSegments: number;
  qualityMetrics: QualityMetric[];
  className?: string;
}

const ContentQualitySectionCard: FC<ContentQualitySectionCardProps> = ({
  state = "Stable",
  filledSegments,
  qualityMetrics,
  className = "",
}) => {
  const getHealthStatus = (): HealthStatusWithLegacy => {
    if (state === "Healthy") return "Healthy";
    if (state === "Stable") return "Stable";
    if (state === "Critical") return "Critical";
    return "Stable";
  };

  return (
    <div className={`${styles.contentQualitySection} ${className}`}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionTitleGroup}>
          <CircleCheckIcon size={16} color="#3F3F46" />
          <Typography
            variant="text-md"
            weight="bold"
            className={styles.sectionTitle}
          >
            Content Quality
          </Typography>
        </div>
        <StatusWithBar
          status={getHealthStatus()}
          filledSegments={filledSegments}
          className={styles.sectionStatusBar}
        />
      </div>
      <div className={styles.metricsGrid}>
        {qualityMetrics.map((metric, index) => (
          <ContentQualityCard
            key={`${metric.category}-${index}`}
            category={metric.category}
            status={metric.status}
            progress={metric.progress}
          />
        ))}
      </div>
    </div>
  );
};

export default ContentQualitySectionCard;
